// This bank's systems on the launcher. `permission` names the user field
// (or fields) that grant access; null means every signed-in user, and
// adminOnly systems are for admins alone.
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import ShowChartRoundedIcon from "@mui/icons-material/ShowChartRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";

export const SYSTEMS = [
  {
    key: "nFass",
    name: "nFass",
    to: "https://narb-nfass.rosoftsavvy.app",
    details: "Financial reporting, analytics and budget",
    permission: "sFass",
    Icon: InsightsRoundedIcon,
    accent: "blue",
  },
  {
    key: "Assets Register",
    name: "Assets Register",
    to: "https://narb-assets-register.cbxapps.com",
    details: "Fixed assets, depreciation and disposals",
    permission: "assets",
    Icon: Inventory2RoundedIcon,
    accent: "indigo",
  },
  {
    key: "Reconciliation",
    name: "Reconciliation",
    to: "https://narb-reconciliation.cbxapps.com",
    details: "Reconciliations and variance tracking",
    permission: "reconciliation",
    Icon: CompareArrowsRoundedIcon,
    accent: "violet",
  },
  {
    key: "Portfolio Manager",
    name: "Portfolio Manager",
    to: "https://narb-investments.cbxapps.com",
    details: "Investment and portfolio management",
    permission: "portfolio_manager",
    Icon: ShowChartRoundedIcon,
    accent: "green",
  },
  {
    key: "Risk Manager",
    name: "Risk Manager",
    to: "https://narb-risk-manager.cbxapps.com",
    details: "Insured assets, cover and risk reporting",
    permission: "risk_manager",
    Icon: ShieldRoundedIcon,
    accent: "amber",
  },
  {
    key: "Stationery Stock",
    name: "Stationery Stock",
    to: "https://narb-stationery-stock.cbxapps.com",
    details: "Stationery stock and movement tracking",
    permission: "stock",
    Icon: WarehouseRoundedIcon,
    accent: "teal",
  },
  {
    key: "eAdvice",
    name: "eAdvice",
    to: "https://narb-advice.cbxapps.com",
    details: "Banking advice and internal communication",
    permission: "e_advice",
    Icon: ForumRoundedIcon,
    accent: "sky",
  },
  {
    key: "eClaim",
    name: "eClaim",
    to: "https://narb-claim.cbxapps.com",
    details: "Expense claims and approvals",
    permission: "e_claim",
    Icon: ReceiptLongRoundedIcon,
    accent: "rose",
  },
  {
    key: "HR",
    name: "HR",
    to: "https://narb-hrms.cbxapps.com",
    details: "Staff records, leave and payroll",
    permission: "hr",
    Icon: GroupsRoundedIcon,
    accent: "indigo",
  },
];

export const ADMIN_CONSOLE = {
  key: "admin-console",
  name: "Admin Console",
  to: "https://narb-admin.cbxapps.com",
  details: "Users, access rights and sign-in security",
};
